export default "__VITE_ASSET__D_PYwriC__"